import script from "./CardTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardTitle.vue?vue&type=script&lang=ts&setup=true"

import "./CardTitle.vue?vue&type=style&index=0&id=6c729dbc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c729dbc"]])

export default __exports__